import { date } from './validate';

// Helper to normalize date strings - replaces hyphen before year with slash
// iPhone Safari interprets hyphen as minus, causing negative years
const normalizeHyphen = (dateString: string): string => {
    return dateString.replace(/[/-](\d{4})(\s|$)/, '/$1$2');
};

export const convertUSDateToEU = (date: string) =>
{
    const d = new Date(normalizeHyphen(date));
    let month = "0" + (d.getMonth() + 1);
    let day = "0" + (d.getDate());
    return `${day.slice(-2)}/${(month.slice(-2))}-${d.getFullYear()}`;
};

export const convertUSDateToEUWithTime = (date: string) =>
{
    const d = new Date(normalizeHyphen(date));
    return convertUSDateToEUWithTimeDate(d);
};

export const convertUSDateToEUWithTimeDate = (d: Date) =>
    {
      
        let month = "0" + (d.getMonth() + 1);
        let day = "0" + (d.getDate());
        let hour = "0" + d.getHours()  ;
        let minutes = "0" + d.getMinutes()
        return `${day.slice(-2)}/${(month.slice(-2))}-${d.getFullYear()} ${(hour.slice(-2))}:${(minutes.slice(-2))}`;
    };
export const convertUSDateToEUWithTimeDateShort = (d: Date) =>
        {
          
            let month = "0" + (d.getMonth() + 1);
            let day = "0" + (d.getDate());
            let hour = "0" + d.getHours()  ;
            let minutes = "0" + d.getMinutes()
            return `${day.slice(-2)}/${(month.slice(-2))}-${d.getFullYear() % 100} ${(hour.slice(-2))}:${(minutes.slice(-2))}`;
        };

export const stringInputToDate = (dateString: string) =>
{
    // Validate that the date is formatted - dd/MM/YYYY
    // Handle both old format (dd/MM-YYYY) and new format (dd/MM/YYYY)
    if ((date(dateString)) !== undefined || date(dateString) !== null)
    {
        const normalizedString = normalizeHyphen(dateString);
        let dateArr = normalizedString.substring(0, 5).split("/");
        let year = normalizedString.substring(6, normalizedString.length).trim();
        let date = new Date(`${dateArr[1]}/${dateArr[0]}/${year}`);
        return date;
    }
}

// Safe date parser without validation - use for parsing application date strings
export const parseDateString = (dateString: string): Date => {
    if (!dateString) return new Date();
    return new Date(normalizeHyphen(dateString));
};

export const datesAreOnSameDay = (first: Date, second: Date) =>
first.getFullYear() === second.getFullYear() &&
first.getMonth() === second.getMonth() &&
first.getDate() === second.getDate();